import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import PageHero from "@/components/PageHero";

export default function About() {
  const { settings } = useSettings();
  const [page, setPage] = useState(null);
  useEffect(() => {
    api.get("/pages/by-slug/quem-somos").then((r) => setPage(r.data)).catch(() => setPage({
      title: "Quem Somos",
      content: "<p>A Marupiara Editoração é uma editora dedicada à literatura brasileira.</p>",
    }));
  }, []);

  return (
    <div>
      <PageHero image={settings.about_hero_image} overline="Nossa história" title={page?.title || "Quem Somos"} align="center" />
      <section className="py-20 bg-[color:var(--marupiara-ivory)]">
        <div className="max-w-3xl mx-auto px-6 prose-editorial text-[color:var(--marupiara-text-on-light)]" dangerouslySetInnerHTML={{ __html: page?.content || "" }} />
      </section>
      <section className="py-20 bg-[color:var(--marupiara-cream)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-8">
          {[
            { title: "Missão", text: "Promover a cultura literária brasileira publicando obras com excelência editorial." },
            { title: "Visão", text: "Ser referência nacional em editoração literária, reconhecida pela sensibilidade e ética." },
            { title: "Valores", text: "Excelência, respeito ao autor, criatividade e compromisso com o leitor." },
          ].map((v) => (
            <div key={v.title} className="bg-white p-8 border border-[color:var(--marupiara-gold)]/25">
              <div className="overline text-[color:var(--marupiara-gold-dark)] mb-2">{v.title}</div>
              <p className="font-serif text-2xl text-[color:var(--marupiara-text-on-light)] leading-snug">{v.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
